module.exports = __webpack_public_path__ + "static/img/vip_biaoshi.edba697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip_biaoshi.png
// module id = /kM2
// module chunks = 1